import React from 'react';
import { CheckCircle2, AlertCircle, AlertTriangle, Sparkles } from 'lucide-react';

/**
 * Componente de Notificação Toast (Padrão Premium)
 */
const Toast = React.memo(({ message, type, isVisible }) => {
    if (!isVisible) return null;

    let icon, iconColor, borderColor;

    switch (type) {
        case 'success':
            icon = <CheckCircle2 size={20} />;
            iconColor = 'text-emerald-400';
            borderColor = 'border-emerald-500/30 dark:border-emerald-500/40';
            break;
        case 'info':
            icon = <AlertCircle size={20} />;
            iconColor = 'text-blue-400';
            borderColor = 'border-blue-500/30 dark:border-blue-500/40';
            break;
        case 'error':
            icon = <AlertTriangle size={20} />;
            iconColor = 'text-rose-400';
            borderColor = 'border-rose-500/30 dark:border-rose-500/40';
            break;
        default:
            icon = <Sparkles size={20} />;
            iconColor = 'text-gray-400';
            borderColor = 'border-white/10';
    }

    return (
        <div 
            className="fixed top-24 inset-x-0 z-[10001] flex items-start justify-center p-4 pointer-events-none animate-in slide-in-from-top-4 duration-300"
            style={{ paddingTop: 'calc(0.5rem + var(--sat, 0px))' }}
        >
            <div className={`pointer-events-auto flex items-center gap-3.5 px-5 py-4 rounded-2xl shadow-[0_25px_60px_-15px_rgba(0,0,0,0.5)] backdrop-blur-xl bg-gray-900/95 dark:bg-black/95 border ${borderColor} max-w-sm w-full transform transition-all`}>
                <div className={`shrink-0 flex items-center justify-center ${iconColor}`}>
                    {icon}
                </div>
                <p className="text-sm font-bold tracking-tight text-white leading-tight">
                    {message}
                </p>
            </div>
        </div>
    );
});

export default Toast;

